import React, { useCallback, useEffect, useState } from "react";
import * as styles from "./settings-integrations.module.scss";
import {
	VelavuAPI,
	VelavuIntegrations,
	VelavuMappedinIntegration,
} from "velavu-js-api";
import LoadingDots from "../../elements/loading-dots";
import MappedinIntegrationSettings from "./settings-integrations/mappedin-integration-settings";
import whitelabel from "../../whitelabel";

export default function SettingsIntegrations() {
	//Fetch integration settings from the backend
	const [integrations, setIntegrations] = useState<VelavuIntegrations | null>(
		null,
	);
	useEffect(() => {
		VelavuAPI.integrations.getIntegrations().then(setIntegrations);
	}, [setIntegrations]);

	const setMappedinIntegration = useCallback(
		(integration: VelavuMappedinIntegration | undefined) => {
			setIntegrations((prev) => {
				if (prev === null) {
					return null;
				} else {
					return {
						...prev,
						mappedin: integration,
					};
				}
			});
		},
		[setIntegrations],
	);

	if (integrations === null) {
		return (
			<div className={styles.loadingContainer}>
				<LoadingDots color={whitelabel.palette.secondary500} />
			</div>
		);
	} else {
		return (
			<div className={styles.container}>
				<MappedinIntegrationSettings
					integration={integrations.mappedin}
					onUpdate={setMappedinIntegration}
				/>
			</div>
		);
	}
}
